import { CategoryType } from 'src/graphql';
import { REPORT_SOURCE } from 'src/types';

export const getDisabledIntakeMethods = (
  categories: CategoryType[],
  isOPREnabled: boolean,
  isVTEnabled: boolean,
) => {
  const allCategoriesOffApp = categories.every(
    (category) => !category.displayInApp,
  );
  const allCategoriesOffVT = categories.every(
    (category) => !category.displayInVaultTalk,
  );
  const allCategoriesOffOPR = categories.every(
    (category) => !category.displayInOpenReporting,
  );
  const allCategoriesOffMI = categories.every(
    (category) => !category.displayInManualIntake,
  );

  const missingIntakeMethods: string[] = [];
  if (allCategoriesOffMI) {
    missingIntakeMethods.push(REPORT_SOURCE['manual-case-creation']);
  }
  if (allCategoriesOffApp) {
    missingIntakeMethods.push(`the ${REPORT_SOURCE.app}`);
  }
  if (isOPREnabled && allCategoriesOffOPR) {
    missingIntakeMethods.push(REPORT_SOURCE['open-reporting']);
  }
  if (isVTEnabled && allCategoriesOffVT) {
    missingIntakeMethods.push(REPORT_SOURCE['vault-talk']);
  }
  return missingIntakeMethods;
};
